import React from 'react'
import _ from 'lodash'
import { GatingContext } from '../core/context'
import styles from './interactive.module.scss'
import { colorToString } from '../widget.helper'

const DownloadButton = ({ iconColor, onDownload }) => {
  const gatingContext = React.useContext(GatingContext)
  const gatingConfigurations = _.get(gatingContext, 'configurations', [])
  const configuration = gatingConfigurations.find(
    (item) => _.get(item, 'trigger.type', '') === 'INTERACTIVE_DOWNLOAD'
  )

  const downloadPdf = () => {
    if (onDownload) {
      onDownload()
    }
  }

  const handleDownloadClick = () => {
    if (configuration && !gatingContext.preview) {
      gatingContext.triggerGating(
        'INTERACTIVE_DOWNLOAD',
        {
          download: downloadPdf
        },
        configuration
      )
      return
    }

    downloadPdf()
  }

  return (
    <div className={styles.downloadLink} onClick={handleDownloadClick}>
      <DownloadIcon fill={colorToString(iconColor)} />
    </div>
  )
}

export default DownloadButton

const DownloadIcon = ({ fill = '#000', ...props }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 200 200'
    width={30}
    height={30}
    {...props}
  >
    <g
      fill='none'
      stroke={fill}
      strokeWidth={9.6}
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M 100 50.8 L 100 149.1' />
      <path d='M 58.4 107.6 L 100 149.1 L 141.6 107.6' />
      <path d='M 55.8 149.1 L 144.2 149.1' />
    </g>
  </svg>
)
